import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import $ from "jquery";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Modal from "react-bootstrap/Modal";
import { CountryDropdown } from "react-country-region-selector";
import { setAlert } from "../../../actions/alertActions";
import { getCountryName, getCountryCode } from "../../utils/Utils";
import "../../../styles/components/evs/modals/ActionEV.scss";
import evsPlaceholder from "../../../styles/images/evsPlaceholder.svg";
import Form from "react-bootstrap/Form";
import LoadingSpinner from "../../utils/components/LoadingSpinner";

class ActionEV extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      isScrolled: false,

      evPicture: evsPlaceholder,
      brands: [],
      models: [],
      versions: [],

      selectedBrand: "",
      selectedModel: "",
      selectedVersion: "",
      selectedChargerPower: "",
      plate: "",
      country: getCountryName(this.props.country) || "",
      otherInfo: "",
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handlePickBrand = this.handlePickBrand.bind(this);
    this.handlePickModel = this.handlePickModel.bind(this);
    this.handlePickVersion = this.handlePickVersion.bind(this);
    this.handlePickChargerPower = this.handlePickChargerPower.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchEVBrands();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.show &&
      this.props.mode === "add" &&
      prevProps.mode !== "add"
    ) {
      this.safeSetState({
        validated: false,
        isScrolled: false,
        evPicture: evsPlaceholder,
        models: [],
        versions: [],
        selectedBrand: "",
        selectedModel: "",
        selectedVersion: "",
        selectedChargerPower: "",
        country: getCountryName(this.props.country) || "",
        plate: "",
        selectedPlug: -1,
        otherInfo: "",
      });
    }
    if (
      this.props.hasOwnProperty("selectedEV") &&
      this.props.selectedEV &&
      this.props.selectedEV.evType === "car"
    )
      if (
        prevProps.selectedEV !== this.props.selectedEV ||
        prevProps.selectedEV.evId !== this.props.selectedEV.evId
      ) {
        const { selectedEV } = this.props;

          this.safeSetState(
            {
              evPicture: selectedEV.imageContent,
              selectedBrand: selectedEV.brand,
              selectedModel: selectedEV.model,
              plate: selectedEV.licensePlate,
              country: getCountryName(selectedEV.country),
              otherInfo: selectedEV.otherInfo,
            },
            () =>
            {
              this.fetchEVModels(() =>
                this.fetchEVVersions(() =>
                {
                  this.safeSetState(
                    {
                      selectedVersion:  this.state.versions.findIndex((v) => {
                          return v.vehicleId == selectedEV.vehicleId;
                        })
                    },
                    () => {
                      const selectedVersion =
                        this.state.versions[this.state.selectedVersion];

                      if (
                        selectedVersion &&
                        Array.isArray(selectedVersion.plugs)
                      ) {
                        const versionPlugs = selectedVersion.plugs;
                        for (let i = 0; i < versionPlugs.length; i++) {
                          const p = versionPlugs[i];
                          if (
                            p.hasOwnProperty("plugPowerAux") &&
                            Array.isArray(p.plugPowerAux)
                          ) {
                            const auxIndex = p.plugPowerAux.findIndex(
                              (aux) =>
                                aux.plugPower ===
                                selectedEV.evInfo.internalChargerPower
                            );
                            this.safeSetState({
                              selectedChargerPower: `${i},${
                                auxIndex !== -1 ? auxIndex : 0
                              }`,
                            });
                            return;
                          }
                        }
                      }
                    }
                  );
                }
                )
              );
            }
              
          );
      }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchEVBrands() {
    axios
      .get("/api/private/evsdb/brands", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ brands: res.data });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchEVModels(callback) {
    axios
      .get("/api/private/evsdb/models", {
        params: {
          brand: this.state.selectedBrand,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ models: res.data }, callback);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchEVVersions(callback) {
    axios
      .get("/api/private/evsdb/versions", {
        params: {
          brand: this.state.selectedBrand,
          model: this.state.selectedModel,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ versions: res.data }, callback);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  handlePickBrand(e) {
    this.safeSetState(
      {
        selectedBrand: e.target.value,
        selectedModel: "",
        selectedVersion: "",
        evPicture: evsPlaceholder,
      },
      this.fetchEVModels
    );
  }

  handlePickModel(e) {
    this.safeSetState(
      {
        selectedModel: e.target.value,
        selectedVersion: "",
        evPicture: evsPlaceholder,
      },
      this.fetchEVVersions
    );
  }

  handlePickVersion(e) {
    this.safeSetState({
      selectedVersion: e.target.value,
      evPicture: this.state.versions[e.target.value].imageContent,
      selectedChargerPower: "0,0",
    });
  }

  handlePickChargerPower(e) {
    this.safeSetState({
      selectedChargerPower: e.target.value,
    });
  }

  handlePlugClick(e, plugIndex) {
    this.safeSetState({
      selectedPlug: plugIndex,
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.toggleLoadingActionCards(true);
        const selectedChargerPower = this.state.selectedChargerPower
          .split(",")
          .map((i) => parseInt(i));
        const versionPlug =
          this.state.versions[this.state.selectedVersion].plugs[
            selectedChargerPower[0]
          ];
        const plugPower =
          versionPlug.hasOwnProperty("plugPowerAux") &&
          Array.isArray(versionPlug.plugPowerAux)
            ? parseFloat(
                versionPlug.plugPowerAux[selectedChargerPower[1]].plugPower
              )
            : parseFloat(versionPlug.plugPower);
        this.props.mode === "add"
          ? this.props.onSubmit(
              Object.assign(
                {},
                this.state.versions[this.state.selectedVersion],
                {
                  plugPower,
                  evType: "car",
                }
              ),
              form.elements.evPlate.value,
              getCountryCode(this.state.country),
              this.state.otherInfo
            )
          : this.props.onSubmit(
              this.state.versions[this.state.selectedVersion],
              Object.assign({}, this.props.selectedEV, {
                evInfo: Object.assign({}, this.props.selectedEV.evInfo, {
                  internalChargerPower: plugPower,
                }),
              }),
              form.elements.evPlate.value,
              getCountryCode(this.state.country),
              this.state.otherInfo,
              this.state.versions[this.state.selectedVersion].vehicleId
            );
      }
    });
  }

  resetState() {
    this.safeSetState({
      validated: false,
      isScrolled: false,

      evPicture: evsPlaceholder,
      models: [],
      versions: [],

      selectedBrand: "",
      selectedModel: "",
      selectedVersion: "",
      selectedChargerPower: "",
      country: getCountryName(this.props.country) || "",
      plate: "",
      selectedPlug: -1,
      otherInfo: "",
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  handleOnChange(e) {
    const { name, value } = e.target;
    this.safeSetState({
      [name]: value,
    });
  }

  render() {
    return (
      <Modal
        id="addEV"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate
              value={this.props.mode === "add" ? "evs_addEV" : "evs_editEV"}
            />
          </Modal.Title>
        </Modal.Header>
        <div
          className={
            "picture-picker-container " +
            (this.state.isScrolled ? "shadowed" : "")
          }
        >
          <button type="button" className="picture-picker">
            <img
              id="picture"
              src={this.state.evPicture || evsPlaceholder}
              onError={(e) => (e.target.src = evsPlaceholder)}
              alt={
                this.state.evPicture !== evsPlaceholder
                  ? "EV picture"
                  : "placeholder"
              }
            />
          </button>
        </div>
        <Modal.Body onScroll={this.handleScroll}>
          <Form
            id="add-ev-form"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleOnSubmit}
            className="ev-properties"
          >
            <Form.Group className="form-field brand" controlId="evBrand">
              <Form.Label>
                <Translate value="evs_brand" />
              </Form.Label>
              <Form.Control
                as="select"
                value={this.state.selectedBrand}
                onChange={this.handlePickBrand}
                required
              >
                <option value="" disabled hidden>
                  {I18n.t("evs_brandSelect")}
                </option>
                {this.state.brands.map((b) => (
                  <option key={b} value={b}>
                    {b}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className="form-field model" controlId="evModel">
              <Form.Label>
                <Translate value="evs_model" />
              </Form.Label>
              <Form.Control
                as="select"
                value={this.state.selectedModel}
                onChange={this.handlePickModel}
                disabled={this.state.selectedBrand === ""}
                required
              >
                <option value="" disabled hidden>
                  {I18n.t("evs_modelSelect")}
                </option>
                {this.state.models.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className="form-field version" controlId="evVersion">
              <Form.Label>
                <Translate value="evs_version" />
              </Form.Label>
              <Form.Control
                as="select"
                value={this.state.selectedVersion}
                onChange={this.handlePickVersion}
                disabled={this.state.selectedModel === ""}
                required
              >
                <option value="" disabled hidden>
                  {I18n.t("evs_versionSelect")}
                </option>
                {this.state.versions.map((v, i) => (
                  <option key={i} value={i}>
                    {v.version !== null
                      ? `${v.version} (${v.dateFrom} - ${
                          v.dateTo !== null
                            ? v.dateTo
                            : I18n.t("evs_datePresent")
                        }) | ${v.plugs.map((p) => p.plugType).join(", ")}`
                      : `${v.dateFrom} - ${
                          v.dateTo !== null
                            ? v.dateTo
                            : I18n.t("evs_datePresent")
                        } | ${v.plugs.map((p) => p.plugType).join(", ")}`}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group
              className="form-field charger-power"
              controlId="evChargerPower"
            >
              <Form.Label>
                <Translate value="evs_chargerPower" />
              </Form.Label>
              <Form.Control
                as="select"
                value={this.state.selectedChargerPower}
                onChange={this.handlePickChargerPower}
                disabled={this.state.selectedVersion === ""}
                required
              >
                <option value="" disabled hidden>
                  {I18n.t("evs_chargerPowerSelect")}
                </option>
                {this.state.selectedVersion !== "" &&
                  this.state.versions[this.state.selectedVersion] &&
                  Array.isArray(
                    this.state.versions[this.state.selectedVersion].plugs
                  ) &&
                  this.state.versions[this.state.selectedVersion].plugs.map(
                    (p, i) => {
                      if (
                        p.hasOwnProperty("plugPowerAux") &&
                        Array.isArray(p.plugPowerAux)
                      ) {
                        return p.plugPowerAux.map((aux, idx) => (
                          <option key={p.plugType + idx} value={[i, idx]}>
                            {`${aux.plugPower} kW - ${p.plugType}`}
                          </option>
                        ));
                      } /*  else
                      return (
                        <option key={p.plugType + "0"} value={[i, 0]}>
                          {`${p.plugPower} kW - ${p.plugType}`}
                        </option>
                      ); */
                    }
                  )}
              </Form.Control>
            </Form.Group>
            <Form.Group className="form-field plate" controlId="evPlate">
              <Form.Label>
                <Translate value="evs_plate" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.plate}
                onChange={(e) => this.safeSetState({ plate: e.target.value })}
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidPlate" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field country" controlId="evCountry">
              <Form.Label>
                <Translate value="evs_country" />
              </Form.Label>
              <Form.Control
                as={CountryDropdown}
                value={this.state.country}
                onChange={(country) => this.safeSetState({ country })}
              ></Form.Control>
            </Form.Group>

            <Form.Group className="form-field otherInfo" controlId="otherInfo">
              <Form.Label>
                <Translate value="myEvs_additionalInfo" />
              </Form.Label>
              <textarea
                name="otherInfo"
                placeholder={I18n.t("myEvs_typeHere")}
                value={this.state.otherInfo}
                onChange={this.handleOnChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {this.props.loading === true ? (
            <LoadingSpinner />
          ) : (
            <button type="submit" form="add-ev-form">
              <Translate
                value={this.props.mode === "add" ? "evs_addEV" : "evs_editEV"}
              />
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  country: state.account.accountData.country,
});

export default connect(mapStateToProps, { setAlert })(ActionEV);
